import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta } from '@angular/platform-browser';

 


@Component({
  selector: 'app-fine-mercato-tutelato',
  templateUrl: './fine-mercato-tutelato.component.html',
  styleUrls: ['./fine-mercato-tutelato.component.scss']
})



export class FineMercatoTutelatoComponent implements OnInit {
  private sub: any;
   


  constructor(  private route: ActivatedRoute, private meta:Meta  ){

    
    this.meta.updateTag({ name: 'title', content: 'La fine del mercato Tutelato' });
    this.meta.updateTag({ name:'description', content:'Cosa succede con la fine del mercato tutelato? '});
    this.meta.updateTag({ name: 'keywords', content: 'Abolizione Mercato Tutelato , Mercato  libero' });

  }

  ngOnInit() {

  }




  async ScrollTopAnimate() {
    //var t = document.getElementById("form");
    var y = window.scrollY;


    for (let posy = y; posy > 0; posy = posy - 25) {
      window.scrollTo(0, posy);
      await this.delay(1);
      console.log(posy);
    }

    window.scrollTo(0, 0);
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  public myfunc(event: Event) {
    // carouselLoad will trigger this funnction when your load value reaches
    // it is helps to load the data by parts to increase the performance of the app
    // must use feature to all carousel
  }


   
}











// WEBPACK FOOTER //
// ./src/app/fine-mercato-tutelato/fine-mercato-tutelato.component.ts